import { Phone, Mail, Globe } from "lucide-react";

export default function Footer() {
  return (
    <footer className="mt-24 border-t border-border" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 py-14 grid gap-10 md:grid-cols-4">
        <div>
          <h3 className="heading-serif text-2xl mb-3">OITS</h3>
          <p className="text-sm text-muted-foreground max-w-xs">
            Travel Together — curated tours, fixed departures and once-in-a-lifetime adventures across the world.
          </p>
        </div>
        <div>
          <h4 className="text-sm uppercase tracking-widest mb-4 text-muted-foreground">Explore</h4>
          <ul className="space-y-2 text-sm">
            <li><a href="/category/international" className="underline-anim">International</a></li>
            <li><a href="/category/domestic" className="underline-anim">Domestic</a></li>
            <li><a href="/category/fixed-departures" className="underline-anim">Fixed Departures</a></li>
            <li><a href="/category/adventure" className="underline-anim">Adventure</a></li>
            <li><a href="/category/devotional" className="underline-anim">Devotional Tour</a></li>
          </ul>
        </div>
        <div>
          <h4 className="text-sm uppercase tracking-widest mb-4 text-muted-foreground">Company</h4>
          <ul className="space-y-2 text-sm">
            <li><a href="/#about" className="underline-anim">About OITS</a></li>
            <li><a href="/#inquiry" className="underline-anim">Custom Inquiry</a></li>
          </ul>
        </div>
        <div>
          <h4 className="text-sm uppercase tracking-widest mb-4 text-muted-foreground">Contact</h4>
          <ul className="space-y-2 text-sm">
            <li className="flex items-center gap-2"><Phone className="h-4 w-4 text-accent" /> 9428609248</li>
            <li className="flex items-center gap-2"><Mail className="h-4 w-4 text-accent" /> booking@oitsinc.in</li>
            <li className="flex items-center gap-2"><Globe className="h-4 w-4 text-accent" /> www.oitsinc.in</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-border py-6 text-center text-xs text-muted-foreground space-y-1">
        <div>© {new Date().getFullYear()} OITS Travel Together.</div>
        <div className="text-[11px] tracking-wide text-muted-foreground/70">Created by Vedant Dave · <a href="mailto:vedantdave611@gmail.com" className="underline-anim">vedantdave611@gmail.com</a></div>
      </div>
    </footer>
  );
}
